import { render, staticRenderFns } from "./notification_record.vue?vue&type=template&id=66960438&scoped=true"
import script from "./notification_record.vue?vue&type=script&lang=js"
export * from "./notification_record.vue?vue&type=script&lang=js"
import style0 from "./notification_record.vue?vue&type=style&index=0&id=66960438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66960438",
  null
  
)

export default component.exports